import { LEAD_API_KEY, LEAD_API_URL, LEAD_SOURCE } from '../constants/site';

export async function submitLead(fields) {
  const response = await fetch(LEAD_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': LEAD_API_KEY,
    },
    body: JSON.stringify({
      ...fields,
      page: typeof window !== 'undefined' ? window.location.href : '',
      source: fields.source || LEAD_SOURCE,
      referrer: typeof document !== 'undefined' ? document.referrer : '',
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'We could not send your request. Please try again.');
  }

  return data;
}
